import angular from 'angular';
import _ from 'lodash';

class legalEntityPerimeterCtrl {
    /* @ngInject */
    constructor(
        $scope,
        $rootScope,
        logger,
        LegalEntityPerimeterDA,
        $uibModal,
        ContainerService,
        KissInvoiceSvc,
        ContainersFilter,
        InvoiceFilter
    ) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.logger = logger;
        this.LegalEntityPerimeterDA = LegalEntityPerimeterDA;
        this.$uibModal = $uibModal;
        this.ContainerService = ContainerService;
        this.KissInvoiceSvc = KissInvoiceSvc;
        this.ContainersFilter = ContainersFilter;
        this.InvoiceFilter = InvoiceFilter;
    }

    $onInit() {
        this.includes = {
            errorMessages: require('../../layouts/error-messages.html'),
        };
        this.deleteEnabled = false;
        this.principal = angular.copy(this.resolve.principal);
        this.legalEntity = angular.copy(this.resolve.legalEntity);
        this.legalEntityPerimeter = angular.copy(this.resolve.legalEntityPerimeter);
        this.update = angular.copy(this.resolve.update);
        this.formatDate = 'dd/MM/yyyy';
        this.datePickerBeginOpened = false;
        this.datePickerEndOpened = false;
        this.platformChoice = 'soc';
        this.canUpdatePerimetre = true;
        this.containerModeKiss = 'KISS';
        this.containerTypeMail = 'MAIL';
        if (!this.update) {
            this.legalEntityPerimeter = { beginDate: new Date() };
        } else {
            this.enableDelete();
            this.canUpdatePerimetre = this.canUpdatePerimeter();
        }
        this.initPlatformChoice();
    }

    /** Gère les conditions d'affichage du périmètre confidentiel */
    canUpdatePerimeter() {

        const perimeterMatchedContainers = this.legalEntity.containers.filter(
            container => container.perimeterCode === this.legalEntityPerimeter.code
        );

        return perimeterMatchedContainers.length === 0 ||
            perimeterMatchedContainers.every(container =>
                container.containerMode === this.containerModeKiss &&
                container.containerType === this.containerTypeMail
            );
    }

    /** Ouvre le datepicker de la date de début de validité. */
    openDatePickerBegin() {
        this.datePickerBeginOpened = true;
    }
    /** Ouvre le datepicker de la date de fin de validité. */
    openDatePickerEnd() {
        this.datePickerEndOpened = true;
    }

    cancel() {
        this.modalInstance.dismiss('cancel');
    }

    updatePerimeter() {
        const PERIMETER_UPDATED_EVENT = 'perimeters:updated';
        if (this.form.$valid && this.checkNotExistCreation() && this.endDateIsValid()) {
            //si on choisit le platformPath de la société, on reinitialise
            if (this.platformChoice === 'soc') {
                this.legalEntityPerimeter.platformPath = null;
            }

            this.LegalEntityPerimeterDA.updatePerimeter(this.legalEntity.id, this.legalEntityPerimeter).then(
                data => {
                    if (this.update) {
                        this.logger.success('success.update', data, null, { entityName: 'Le périmètre' });
                    } else {
                        this.logger.success('success.create', data, null, { entityName: 'Le périmètre' });
                    }
                    var res = {
                        updated: this.update,
                        perimeter: this.legalEntityPerimeter,
                    };
                    this.$rootScope.$emit(PERIMETER_UPDATED_EVENT, res.perimeter);
                    this.modalInstance.close(res);
                },
                error => {
                    // Echec
                    this.logger.error('error.save', error);
                }
            );
        }
    }

    /** Vérifie lors d'une création que le périmètre n'existe pas déjà. */
    checkNotExistCreation() {
        if (!this.update && _.find(this.legalEntity.perimeters, { code: this.legalEntityPerimeter.code })) {
            this.logger.error('error.perimeter.creation', 'Duplication of perimeter code');
            return false;
        }
        return true;
    }

    /** Si la date de début est renseignée, vérifie que la date de fin de validité est supérieur à celle de début de validité. */
    endDateIsValid() {
        return !(this.legalEntityPerimeter.endDate && this.legalEntityPerimeter.beginDate && this.legalEntityPerimeter.endDate.getTime() <= this.legalEntityPerimeter.beginDate.getTime());
    }

    initPlatformChoice() {
        this.platformChoice = this.legalEntityPerimeter && this.legalEntityPerimeter.platformPath ? 'per' : 'soc';
    }

    /** vérifie si le perimètre est dans un container qui a un pli ou un fournisseur invité */
    /**puis vérifie si le périmètre n'a pas de facture*/
    enableDelete() {
        this.LegalEntityPerimeterDA.checkPerimeterDeletion(this.legalEntity.id, this.legalEntityPerimeter.code).then(
            data => {
                this.deleteEnabled = data;
            }
        );
    }

    openDeletePerimeterConfirmModal() {
        this.$uibModal
            .open({
                component: 'modalPerimeterDelete',
                size: 'lg',
                backdrop: 'static',
            })
            .result.then(
                () => {
                    this.deletePerimeter();
                },
                () => {
                    this.dismissModal();
                }
            );
    }

    deletePerimeter() {
        this.LegalEntityPerimeterDA.deletePerimeter(this.legalEntity.id, this.legalEntityPerimeter.code).then(
            () => {
                var res = {
                    deleted: true,
                    perimeter: this.legalEntityPerimeter,
                };
                this.modalInstance.close(res);
            },
            () => {
                this.modalInstance.close();
                this.logger.error('error.delete');
            }
        );
    }
}

angular.module('app.principal').component('legalEntityPerimeter', {
    templateUrl: require('./modal-legal-entity-perimeter.html'),
    controller: legalEntityPerimeterCtrl,
    bindings: {
        modalInstance: '<',
        resolve: '<',
    },
});
